import { render, staticRenderFns } from "./SelectMoeda.vue?vue&type=template&id=58db0872"
import script from "./SelectMoeda.vue?vue&type=script&lang=js"
export * from "./SelectMoeda.vue?vue&type=script&lang=js"
import style0 from "./SelectMoeda.vue?vue&type=style&index=0&id=58db0872&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports